import React from "react";
import { ChakraProvider, Box } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import Category from "./pages/Category";
import ProductDetail from "./pages/ProductDetail";
import { CartProvider } from "./context/CartContext";
import AllProducts from "./pages/AllProducts";
import Categories from "./pages/Categories";
import Sale from "./pages/Sale";
import CategoryPage from "./pages/CategoryPage";
import Contact from "./pages/Contact";
import About from "./pages/About";

const App: React.FC = () => {
  return (
    <ChakraProvider>
      <CartProvider>
        <Router>
          <Box minH="100vh" display="flex" flexDirection="column">
            <Header />
            <Box flex="1" pt="80px">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-success" element={<OrderSuccess />} />
                <Route
                  path="/category/:categoryId"
                  element={<CategoryPage />}
                />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/products" element={<AllProducts />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/sale" element={<Sale />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </Router>
      </CartProvider>
    </ChakraProvider>
  );
};

export default App;
